<template>
  <div class="group-details">
    <v-row align="center">
      <v-col>
        <v-breadcrumbs :items="breadcrumb" large></v-breadcrumbs>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary" icon dark class="mr-4" @click="refresh">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-tabs v-model="tab" background-color="primary" dark icons-and-text grow>
      <v-tab href="#tab-users">
        <span class="mt-2">Users</span>
        <v-icon>people</v-icon>
      </v-tab>
      <v-tab-item value="tab-users" class="grey lighten-5">
        <v-container>
          <GroupUsers :group="group" />
        </v-container>
      </v-tab-item>
      <v-tab href="#tab-roles">
        <span class="mt-2">Roles</span>
        <v-icon>policy</v-icon>
      </v-tab>
      <v-tab-item value="tab-roles" class="grey lighten-5">
        <v-container>
          <GroupRoles :group="group" />
        </v-container>
      </v-tab-item>
    </v-tabs>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import GroupUsers from "./GroupUsers";
import GroupRoles from "./GroupRoles";

export default {
  mixins: [mixin],
  components: {
    GroupUsers,
    GroupRoles
  },
  data() {
    return {
      tab: null,
      groupUuid: this.$route.params.groupId,
      initialUuid: "",
      snackbar: false,
      errorMessage: "",
      group: {}
    };
  },
  computed: {
    ...mapState({
      currentOrganization: state => state.organizations.current,
      fetchGroupError: state =>
        state.organizations.fetchOrganizationGroup.error,
      fetchGroupLoading: state =>
        state.organizations.fetchOrganizationGroup.pending
    }),
    breadcrumb() {
      return [
        {
          text: "Groups",
          disabled: false,
          href: "#/access/groups"
        },
        {
          text: this.group ? this.group.name : "unknown",
          disabled: true
        }
      ];
    }
  },
  watch: {
    currentOrganization() {
      if (
        this.currentOrganization &&
        this.currentOrganization.uuid !== this.initialUuid
      ) {
        this.$router.push("/access/groups");
      }
    }
  },
  methods: {
    ...mapActions("organizations", {
      fetchOrganizationGroup: "fetchOrganizationGroup"
    }),
    refresh() {
      this.fetchOrganizationGroup({
        organizationUuid: this.currentOrganization.uuid,
        groupUuid: this.groupUuid
      })
        .then(group => {
          this.group = group;
          this.initialUuid = this.currentOrganization.uuid;
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    if (this.currentOrganization) {
      this.refresh();
    } else {
      this.$router.push("/access/groups");
    }
  }
};
</script>

<style>
</style>